import { render, staticRenderFns } from "./unregisterdevice.vue?vue&type=template&id=47f39ef1&scoped=true&"
import script from "./unregisterdevice.vue?vue&type=script&lang=js&"
export * from "./unregisterdevice.vue?vue&type=script&lang=js&"
import style0 from "./unregisterdevice.vue?vue&type=style&index=0&id=47f39ef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f39ef1",
  null
  
)

export default component.exports